import BulkInquiryState from './types'

const initialState: BulkInquiryState = {
    selectedListings: {},
    selectionOrder: [],
    isSelectMode: false,
    filterKey: null,
}

export default initialState
